import styled, { css } from 'styled-components'
import { PRIMARY, SECONDARY } from '../../../../shared/styles/colors'
import { fontSize } from '../../../../shared/styles/mixins'

export const Wrapper = styled.article`
  ${fontSize(14)}
  width: 190px;
  color: ${PRIMARY};
  display: grid;
  align-items: center;
  grid-gap: 3px 8px;
  grid-template-columns: 35px 140px;
  grid-template-rows: 16px 16px;
  grid-template-areas:
    'icon title'
    'icon description';
  @media (min-width: 601px) {
    ${({ icon }) =>
      !icon &&
      css`
        grid-template-columns: 0 140px;
        grid-template-rows: 16px 16px;
        grid-template-areas:
          '. title'
          '. description';
      `}
  }
  @media (max-width: 600px) {
    margin-bottom: 16px;
  }
`

export const Title = styled.span`
  grid-area: title;
`

export const Description = styled.a`
  grid-area: description;
  color: ${SECONDARY};
`
